// extracted by mini-css-extract-plugin
export var featuredTowns = "styles-module--featuredTowns--13Lbu";
export var mainContainer = "styles-module--mainContainer--1RmN3";
export var photo = "styles-module--photo--2GIHT";
export var positive = "styles-module--positive--1TB5T";
export var townItem = "styles-module--townItem--SjAcq";